// import BreakSystem from '../components/defectsComponent/BreakSystem';
// import SteeringMechanism from '../components/defectsComponent/SteeringMechanism';

const InspectinDefectsData = [
  {
    name: '1. Brake System',
    // component: <BreakSystem />,
  },
  {
    name: '2. Coupling Devices',
    text: `
A. Fifth Wheels.
(1) Mounting to frame.
(a) Any fasteners missing or ineffective.
(b) Any movement between mounting components.
(c) Any mounting angle iron cracked or broken.
(2) Mounting plates and pivot brackets.
(a) Any fasteners missing or ineffective.
(b) Any welds or parent metal cracked.
(c) More than 3⁄8 inch horizontal movement between pivot bracket pin and bracket.
(d) Pivot bracket pin missing or not secured.
(3) Sliders.
(a) Any latching fasteners missing or ineffective.
(b) Any fore or aft stop missing or not securely attached.
(c) Movement more than 3⁄8 inch between slider bracket anslider base.
(d) Any slider component cracked in parent metal or weld.
(4) Lower coupler.
(a) Horizontal movement between the upper and lower fifth wheel halves exceeds 1⁄2 inch.
(b) Operating handle not in closed or locked position.
(c) Kingpin not properly engaged.
(d) Separation between upper and lower coupler allowing light to show through from side to side.
(e) Cracks in the fifth wheel plate.
Exceptions: Cracks in fifth wheel approach ramps and casting shrinkage cracks in the ribs of the body of a cast fifth wheel.
(f) Locking mechanism parts missing, broken, or deformed to the extent the kingpin is not securely held.
B. Pintle Hooks.
(1) Mounting to frame.
(a) Any missing or ineffective fasteners (a fastener is not considered missing if there is an empty hole in the device but no corresponding hole in the frame or vice versa).
(b) Mounting surface cracks extending from point of attachment (e.g., cracks in the frame at mounting bolt holes).
(c) Loose mounting.
(d) Frame cross member providing pintle hook attachment cracked.
(2) Integrity.
(a) Cracks anywhere in pintle hook assembly.
(b) Any welded repairs to the pintle hook.
(c) Any part of the horn section reduced by more than 20%.
(d) Latch insecure.
C. Drawbar/Towbar Eye.
(1) Mounting.
(a) Any cracks in attachment welds.
(b) Any missing or ineffective fasteners.
(2) Integrity.
(a) Any cracks.
(b) Any part of the eye reduced by more than 20%.
D. Drawbar/Towbar Tongue.
(1) Slider (power or manual).
(a) Ineffective latching mechanism
(b) Missing or ineffective stop.
(c) Movement of more than 1⁄4 inch between slider and housing.
(d) Any leaking, air or hydraulic cylinders, hoses, or chambers (other than slight oil weeping normal with hydraulic seals).
(2) Integrity.
(a) Any cracks.
(b) Movement of 1⁄4 inch between subframe and drawbar at point of attachment.
E. Safety Devices.
(1) Safety devices missing.
(2) Unattached or incapable of secure attachment.
(3) Chains and hooks.
(a) Worn to the extent of a measurable reduction in link cross section.
(b) Improper repairs including welding, wire, small bolts, rope and tape.
(4) Cable.
(a) Kinked or broken cable strands.
(b) Improper clamps or clamping.
F. Saddle-Mounts.
(1) Method of attachment.
(a) Any missing or ineffective fasteners.
(b) Loose mountings.
(c) Any cracks or breaks in a stress or load bearing member.
(d) Horizontal movement between upper and lower saddle-mount halves exceeds 1⁄4 inch.
    `,
  },
  {
    name: '3. Exhaust System',
    text: `
A. Any exhaust system determined to be leaking at a point forward of or directly below the driver/sleeper compartment.
B. A bus exhaust system leaking or discharging to the atmosphere:
(1) Gasoline powered—excess of 6 inches forward of the rearmost part of the bus.
(2) Other than gasoline powered—in excess of 15 inches forward of the rearmost part of the bus.
(3) Other than gasoline powered—forward of a door or window designed to be opened. (exception: Emergency exits).
C. No part of the exhaust system of any motor vehicle shall be so located as would be likely to result in burning, charring, or damaging the electrical wiring, the fuel supply, or any combustible part of the motor vehicle.
`,
  },
  {
    name: '4. Fuel System',
    text: `
a. A fuel system with a visable leak at any point.
b. A fuel tank filler cap missing.
c. A fuel tank not securely attached to the motor vehicle by reason of loose, broken or missing mounting bolts or brackets (some fuel tanks use springs or rubber bushings to permit movement).
5. Lighting Devices. All lighting devices and reflectors required by part 393 shall be operable.
6. Safe Loading.
a. Part(s) of vehicle or condition of loading such that the spare tire or any part of the load or dunnage can fall onto the roadway.
b. Protection Against Shifting Cargo—Any vehicle without a front-end structure or equivalent device as required.
c. Container securement devices on intermodal equipment—All devices used to secure an intermodal container to a chassis, including rails or support frames, tiedown bolsters, locking pins, clevises, clamps, and hooks that are cracked, broken, loose, or missing.
    `,
  },
  {
    name: '5. Lighting Devices',
    text: `
    All lighting devices and reflectors required by part 393 shall be operable.
    `,
  },
  {
    name: '6. Safe Loading',
    text: `
A. Part(s) of vehicle or condition of loading such that the spare tire or any part of the load or dunnage can fall onto the roadway.
B. Protection Against Shifting Cargo—Any vehicle without a front-end structure or equivalent device as required.
C. Container securement devices on intermodal equipment—All devices used to secure an intermodal container to a chassis, including rails or support frames, tiedown bolsters, locking pins, clevises, clamps, and hooks that are cracked, broken, loose, or missing.
    `,
  },
  {
    name: '7. Steering Mechanism',
    // component: <SteeringMechanism />,
  },
  {
    name: '8. Suspension',
    text: `
A. Any U-bolt(s), spring hanger(s), or other axle positioning part(s) cracked, broken, loose or missing resulting in shifting of an axle from its normal position. (After a turn, lateral axle displacement is normal with some suspensions. Forward or rearward operation in a straight line will cause the axle to return to alignment).
B. Spring Assembly.
(1) Any leaves in a leaf spring assembly broken or missing.
(2) Any broken main leaf in a leaf spring assembly. (Includes assembly with more than one main spring).
(3) Coil spring broken.
(4) Rubber spring missing.
(5) One or more leaves displaced in a manner that could result in contact with a tire, rim, brake drum or frame.
(6) Broken torsion bar spring in a torsion bar suspension.
(7) Deflated air suspension, i.e., system failure, leak, etc.
C. Torque, Radius or Tracking Components. Any part of a torque, radius or tracking component assembly or any part used for attaching the same to the vehicle frame or axle that is cracked, loose, broken or missing. (Does not apply to loose bushings in torque or track rods.)
    `,
  },
  {
    name: '9. Frame',
    text: `
A. Frame Members.
(1) Any cracked, broken, loose, or sagging frame member.
(2) Any loose or missing fasteners including fasteners attaching functional component such as engine, transmission, steering gear, suspension, body parts, and fifth wheel.
B. Tire and Wheel Clearance. Any condition, including loading, that causes the body or frame to be in contact with a tire or any part of the wheel assemblies.
C. (1) Adjustable Axle Assemblies (Sliding Subframes). Adjustable axle assembly with locking pins missing or not engaged.
    `,
  },
  {
    name: '10. Tires',
    text: `
A. Any tire on any steering axle of a power unit.
(1) With less than 4⁄32 inch tread when measured at any point on a major tread groove.
(2) Has body ply or belt material exposed through the tread or sidewall.
(3) Has any tread or sidewall separation.
(4) Has a cut where the ply or belt material is exposed.
(5) Labeled “Not for Highway Use” or displaying other marking which would exclude use on steering axle.
(6) A tube-type radial tire without radial tube stem markings. These markings include a red band around the tube stem, the word “radial” embossed in metal stems, or the word “radial” molded in rubber stems.
(7) Mixing bias and radial tires on the same axle.
(8) Tire flap protrudes through valve slot in rim and touches stem.
(9) Regrooved tire except motor vehicles used solely in urban or suburban service (see exception in §393.75(e).
(10) Boot, blowout patch or other ply repair.
(11) Weight carried exceeds tire load limit. This includes overloaded tire resulting from low air pressure.
(12) Tire is flat or has noticeable (e.g., can be heard or felt) leak.
(13) Any bus equipped with recapped or retreaded tire(s).
(14) So mounted or inflated that it comes in contact with any part of the vehicle.
B. All tires other than those found on the steering axle of a power unit:
(1) Weight carried exceeds tire load limit. This includes overloaded tire resulting from low air pressure.
(2) Tire is flat or has noticeable (e.g., can be heard or felt) leak.
(3) Has body ply or belt material exposed through the tread or sidewall.
(4) Has any tread or sidewall separation.
(5) Has a cut where ply or belt material is exposed.
(6) So mounted or inflated that it comes in contact with any part of the vehicle. (This includes a tire that contacts its mate.)
(7) Is marked “Not for highway use” or otherwise marked and having like meaning.
(8) With less than 2⁄32 inch tread when measured at any point on a major tread groove.
C. Installation of speed-restricted tires unless specifically designated by motor carrier.
    `,
  },
  {
    name: '11. Wheels and Rims',
    text: `
A. Lock or Side Ring. Bent, broken, cracked, improperly seated, sprung or mismatched ring(s).
B. Wheels and rims. Cracked or broken or has elongated bolt holes.
C. Fasteners (both spoke and disc wheels). Any loose, missing, broken, cracked, stripped or otherwise ineffective fasteners.
D. Welds.
(1) Any cracks in welds attaching disc wheel disc to rim.
(2) Any crack in welds attaching tubeless demountable rim to adapter.
(3) Any welded repair on aluminum wheel(s) on a steering axle.
(4) Any welded repair other than disc to rim attachment on steel disc wheel(s) mounted on the steering axle.
    `,
  },
  {
    name: '12. Windshield Glazing',
    text: `
(Not including a 2 inch border at the top, a 1 inch border at each side and the area below the topmost portion of the steering wheel.) Any crack, discoloration or vision reducing matter except: (1) coloring or tinting applied at time of manufacture; (2) any crack not over 1⁄4 inch wide, if not intersected by any other crack; (3) any damaged area not more than 3⁄4 inch in diameter, if not closer than 3 inches to any other such damaged area; (4) labels, stickers, decalcomania, etc. (see §393.60 for exceptions).
    `,
  },
  {
    name: '13. Windshield Wipers',
    text: `
Any power unit that has an inoperative wiper, or missing or damaged parts that render it ineffective.
    `,
  },
  {
    name: '14. Motor Coach Seats',
    text: `
a. Any passenger seat that is not securely fastened to the vehicle structure.
b. [Reserved]
    `,
  },
];

export default InspectinDefectsData;


// WEBPACK FOOTER //
// ./src/data/defects.js